/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_race_perf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Season-total counts for key race performance metrics`)
};

const es_f1_profile_tooltip_race_perf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totales de temporada para métricas clave de rendimiento en carrera`)
};

const de_f1_profile_tooltip_race_perf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisongesamtwerte für wichtige Rennleistungskennzahlen`)
};

const nl_f1_profile_tooltip_race_perf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seizoenstotalen voor belangrijke raceprestatie-indicatoren`)
};

const fr_f1_profile_tooltip_race_perf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaux de la saison pour les principales métriques de performance en course`)
};

const it_f1_profile_tooltip_race_perf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteggi totali della stagione per le principali metriche di prestazione`)
};

const pt_br2_f1_profile_tooltip_race_perf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contagens totais da temporada para métricas-chave de desempenho na corrida`)
};

const pt_f1_profile_tooltip_race_perf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totais da época para métricas-chave de desempenho na corrida`)
};

const ja_f1_profile_tooltip_race_perf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズン通算の主要レースパフォーマンス指標`)
};

const zh_f1_profile_tooltip_race_perf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关键比赛表现指标的赛季总计`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_race_perf = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_race_perf(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_race_perf", locale)
	if (locale === "en") return en_f1_profile_tooltip_race_perf(inputs)
	if (locale === "es") return es_f1_profile_tooltip_race_perf(inputs)
	if (locale === "de") return de_f1_profile_tooltip_race_perf(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_race_perf(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_race_perf(inputs)
	if (locale === "it") return it_f1_profile_tooltip_race_perf(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_race_perf(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_race_perf(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_race_perf(inputs)
	return zh_f1_profile_tooltip_race_perf(inputs)
};